export const formatDate = (value?: string | Date | number | null): string => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleDateString("vi-VN");
};

export const formatCurrency = (value?: number | string | null): string => {
  const numberValue = Number(value || 0);
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
    maximumFractionDigits: 0,
  }).format(numberValue);
};

export const formatIntegerInput = (value: unknown): string => {
  const digits = String(value || "").replace(/\D/g, "");
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const parseIntegerInput = (value: unknown): number =>
  Number(String(value || "").replace(/\D/g, "") || 0);

export const blockNonNumericKey = (event: KeyboardEvent) => {
  if (
    event.ctrlKey ||
    event.metaKey ||
    [
      "Backspace",
      "Delete",
      "Tab",
      "Escape",
      "Enter",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Home",
      "End",
    ].includes(event.key)
  ) {
    return;
  }

  if (!/^\d$/.test(event.key)) {
    event.preventDefault();
  }
};

export const pasteNumericOnly = (
  event: ClipboardEvent,
  updateValue: (value: string) => void,
) => {
  const text = event.clipboardData?.getData("text") || "";
  if (!/^\d+$/.test(text)) {
    event.preventDefault();
    updateValue(text.replace(/\D/g, ""));
  }
};

export const toTimestamp = (value?: string | Date | null): number => {
  if (!value) return 0;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? 0 : date.getTime();
};

export const normalizeText = (value: unknown): string =>
  String(value || "").toLowerCase().trim();
